import { COMPONENT_STATES, COMPONENT_TYPE, DEFAULT_MEDIA_QUERY_PLATFORMS } from 'common/constants';
import { OTHER_PROPS } from 'common/constants/component-props';
import { BOX_TYPE } from '../box/constants';
import { createModel } from '../create-model';
import type { CreatedBuildingBlock } from '../creation-types';

export const sortableBox = (): CreatedBuildingBlock<typeof COMPONENT_TYPE.SORTABLE_BOX> =>
	createModel({
		type: COMPONENT_TYPE.SORTABLE_BOX,
		editorProps: {
			expandable: true,
			expanded: true,
		},
		componentProps: {
			styles: {},
			other: {
				[COMPONENT_STATES.DEFAULT]: {
					[DEFAULT_MEDIA_QUERY_PLATFORMS.DEFAULT]: {
						[OTHER_PROPS.box.boxType]: BOX_TYPE.STACK,
					},
				},
			},
		},
		children: [],
	}) satisfies CreatedBuildingBlock<typeof COMPONENT_TYPE.SORTABLE_BOX>;
